import React, { useEffect, useState } from "react";
import "./RevenueAnalytics.scss";
import LineChart from "../Charts/LineChart/LineChart";
import { useSelector } from "react-redux";
import { format } from "date-fns";

const RevenueAnalytics = () => {
  const { currency } = useSelector((state) => state.organizationReducer.value);

  const { revenueAnalytics: revenueAnalyticsData } = useSelector(
    (state) => state.analyticsReducer
  );

  const [data, setData] = useState({
    labels: [],

    datasets: [
      {
        label: "Revenue",
        data: [],
        backgroundColor: "#65C1E8",
        borderColor: "#65C1E8",
      },
    ],
  });

  useEffect(() => {
    const labels = [];

    const dataSet = [];

    revenueAnalyticsData?.revenue_by_day?.forEach((el) => {
      labels.push(el?.day || "N/A");
      dataSet.push(Number(el?.amount));
    });

    setData({
      labels: labels,

      datasets: [
        {
          label: "Revenue",
          data: dataSet,
          backgroundColor: "#65C1E8",
          borderColor: "#65C1E8",
        },
      ],
    });
  }, [revenueAnalyticsData]);

  return (
    <div className="revenue-analytics">
      <div className="container-wrapper revenue">
        <p className="heading">Revenue Graph</p>

        <div className="sales-chart">
          <div className="title-list">
            {/* <p className="table-head">Hourly</p>
            <p className="table-head">Day</p>
            <p className="table-head">Week Day</p> */}
          </div>

          <div className="chart-container">
            <p className="chart-title">
              <span>Total:</span> {currency}
              {revenueAnalyticsData?.total_revenue || "0.00"}
            </p>
            <LineChart data={data} currency={currency} />
          </div>
        </div>

        <p className="heading">Revenue Record</p>

        <div className="revenue-table">
          <div className="row head">
            <p>S.N.</p>
            <p>Date</p>
            <p>Revenue</p>
            <p>Sales</p>
          </div>

          <div className="table-body">
            {revenueAnalyticsData?.revenue_by_day?.map((el, i) => {
              return (
                <div className="row" key={i}>
                  <p>{i + 1}</p>
                  <p>{el?.date ? format(el?.date, "dd/MM/yyyy") : ""}</p>
                  <p className="price">
                    {currency}
                    {Number(el?.amount).toFixed(2) || "0.00"}
                  </p>
                  <p className="sales-font">{el?.sales_count || 0}</p>
                </div>
              );
            })}

            <div className="row total">
              <p></p>
              <p>Total</p>
              <p>
                {currency}
                {revenueAnalyticsData?.total_revenue || "0.00"}
              </p>
              <p>{revenueAnalyticsData?.total_sales || 0}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RevenueAnalytics;
